import { useGSAP } from '@gsap/react';
import { graphql } from 'gatsby';
import React, { useRef } from 'react';
import { SanityImageType } from '../../../graphql-fragments/SanityImage';
import { BackgroundColorTheme, ModuleBgColor } from '../../../templates/Page';
import { getPortableText } from '../../../utils/sanity';
import { CommonModuleProps } from '../../ModulesContent';
import TextAndImageModule from './TextAndImageModule';

export const DocumentsModuleFragment = graphql`
  fragment DocumentsModule on SanityPageDocumentsModule {
    title {
      ...LocaleStringFragment
    }
    text {
      ...LocaleTextFragment
    }
    image {
      ...SanityImage
    }
    documents {
      name {
        ...LocaleStringFragment
      }
      description {
        ...LocaleTextFragment
      }
      file {
        ...LocaleFileFragment
      }
      link
    }
    backgroundColor
  }
`;

export interface DocumentsModuleProps {
  title: string;
  text?: string;
  image: SanityImageType;
  documents: Array<{
    name: string;
    description?: string;
    file?: {
      asset: {
        url: string;
        size: number;
      };
    };
    link?: string;
  }>;
  backgroundColor: BackgroundColorTheme;
  className?: string;
}

export function getModuleBgColor(props: DocumentsModuleProps): ModuleBgColor {
  /**
   * The purpose of this function is to let other modules know which background color this module has.
   * Knowing this, we can use this function to make decisions about the layout and spacing between modules.
   */
  return 'colored';
}

function DocumentsModule(props: DocumentsModuleProps & CommonModuleProps): React.ReactElement {
  const {
    title,
    text,
    image,
    documents,
    backgroundColor,
    className,
    previousModuleBgColor,
    moduleId,
  } = props;

  const containerRef = useRef<HTMLElement | null>(null);

  useGSAP(() => {}, { scope: containerRef });

  return (
    <TextAndImageModule
      image={image}
      title={title}
      text={text ? getPortableText([{ text: text }]) : undefined}
      backgroundColor={backgroundColor}
      imageOrientation="portrait"
      imageSide="right"
      fileRows={documents}
      moduleId={moduleId}
      className={className}
      previousModuleBgColor={previousModuleBgColor}
    />
  );
}

export default DocumentsModule;
